import { Component, OnDestroy, OnInit } from '@angular/core';
import { NotificationService } from '../notification.service';
import { NotificationHandler } from '../notification-handler';
import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
    selector: 'jow-notification',
    styleUrls: [],
    template: ` `,
    standalone: false
})
export class NotificationComponent implements OnInit, OnDestroy {

  private subscription = new Subscription();

  constructor(private notificationService: NotificationService, private notificationHandler: NotificationHandler) {}

  ngOnInit() {
    this.subscription.add(this.notificationService.messages
      .subscribe(args => {
        this.notificationHandler.handle('message', args.title, args.message);
      }));

    this.subscription.add(this.notificationService.errors
      .subscribe(message => {
          this.notificationHandler.handle('error', 'error', message);
      }));

    this.subscription.add(this.notificationService.badRequests
      .subscribe(message => {
        this.notificationHandler.handle('warning', 'invalid request', message);
      }));

    this.subscription.add(this.notificationService.serverErrors.pipe(debounceTime(500))
      .subscribe((message) => {
        this.notificationHandler.handle('error', 'error', message);
      }));

    this.subscription.add(this.notificationService.permissionErrors.pipe(debounceTime(500))
      .subscribe((message) => {
        this.notificationHandler.handle('warning', 'warning', message);
      }));

    this.subscription.add(this.notificationService.unauthorizedErrors.pipe(debounceTime(500))
      .subscribe((message) => {
        this.notificationHandler.handle('error', 'error', message);
      }));

    this.subscription.add(this.notificationService.conflictErrors
      .subscribe(message => {
        this.notificationHandler.handle('warning', 'conflicting change', message);
      }));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
